




























import { Component, Vue, Emit, Prop, Watch } from 'vue-property-decorator';
import { disableBodyScroll, enableBodyScroll } from '../../../common/scroll';

/**
 * 全屏弹窗
 */
@Component
export default class ScreenDialog extends Vue {
  /** 点击遮罩层是否关闭 */
  @Prop({ default: false }) clickMaskHide!: boolean;
  /** 是否展示关闭按钮 */
  @Prop({ default: true }) isShowClose!: boolean;
  /** 是否挂载到body中 */
  @Prop({ default: false }) isAppendToBody!: boolean;
  /** 是否动态加载到dom中 */
  @Prop({ default: false }) isDynamicLoad!: boolean;
  isShow = false;
  @Emit('show')
  show() {
    this.isShow = true;
  }
  @Emit('hide')
  hide() {
    this.isShow = false;
  }
  @Emit('clickBtn')
  private clickBtn() {
    this.hide();
  }
  @Emit('clickMask')
  private clickMask() {
    if (this.clickMaskHide) this.hide();
  }
  @Watch('isShow')
  private handleIsShowChange() {
    if (this.isShow) {
      disableBodyScroll();
    } else {
      enableBodyScroll();
    }
  }

  private mounted() {
    if (this.isAppendToBody) {
      document.body.appendChild(this.$el);
    }
  }

  private destroyed() {
    if (this.isAppendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    enableBodyScroll();
  }
}
